// Regroupement des jobs par urgence (liste des jobs).
import type { Job } from "../data/types.ts";
import { addDays, startOfDay } from "./time.ts";

export type Group = { key: string; label: string; tone: string; rows: Job[] };

/** Regroupe les jobs par urgence : retard, aujourd'hui, demain, cette semaine, plus tard, terminés. */
export function groupJobs(jobs: Job[], now = new Date()): Group[] {
  const today = startOfDay(now).getTime();
  const tomorrow = addDays(new Date(today), 1).getTime();
  const after = addDays(new Date(today), 2).getTime();
  const weekEnd = addDays(new Date(today), 7).getTime();
  const groups: Group[] = [
    { key: "retard", label: "En retard", tone: "red", rows: [] },
    { key: "jour", label: "Aujourd'hui", tone: "orange", rows: [] },
    { key: "demain", label: "Demain", tone: "", rows: [] },
    { key: "semaine", label: "Dans les 7 jours", tone: "", rows: [] },
    { key: "plus", label: "Plus tard", tone: "", rows: [] },
    { key: "fini", label: "Terminés et annulés", tone: "", rows: [] },
  ];
  const at = (k: string) => groups.find((g) => g.key === k)!.rows;
  for (const j of jobs) {
    const d = new Date(j.due_at).getTime();
    if (j.status === "termine" || j.status === "annule") at("fini").push(j);
    else if (d < now.getTime()) at("retard").push(j);
    else if (d < tomorrow) at("jour").push(j);
    else if (d < after) at("demain").push(j);
    else if (d < weekEnd) at("semaine").push(j);
    else at("plus").push(j);
  }
  for (const g of groups) g.rows.sort((x, y) => (g.key === "fini" ? y.due_at.localeCompare(x.due_at) : x.due_at.localeCompare(y.due_at)));
  return groups.filter((g) => g.rows.length);
}
